import { Component } from '@angular/core';


@Component({
   selector: 'bb-loading',
   templateUrl: './loading.component.html',
   styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent {}
